import React, {useContext, useEffect, useState} from 'react';
import {MapContext} from './MapContext';
import {calculateDistance, formatLatLng, moveMapEl} from '../../common/helper';
import {useSelector} from 'react-redux';
import {selectActiveUser} from '../dashboard/dashboardSlice';
import {currentUserLocation, locationByID, ORMLocations} from '../../app/models/ormSelectors';

const Circle = () => {
    const {googleMap} = useContext(MapContext);
    const currentUserLoc = useSelector(currentUserLocation)[0];
    const [circle, setCircle] = useState(null);
    const activeUser = useSelector(selectActiveUser);
    const geoByID = useSelector(locationByID);
    const ormLocations = useSelector(ORMLocations);
    const accuracy = geoByID(activeUser).location ? geoByID(activeUser).location.accuracy : 5;

    useEffect(() => {
        if (circle) {
            circle.setMap(null)
        }

        if (geoByID(activeUser).location) {
            const latLng = formatLatLng(currentUserLoc.lat, currentUserLoc.lng);

            const circle = new google.maps.Circle({
                center: latLng,
                radius: accuracy,
                fillColor: '#00BFA5',
                fillOpacity: '0.3',
                map: googleMap,
                strokeColor: 'transparent',
            });

            setCircle(circle);
        }

    }, [activeUser]);

    useEffect(() => {
        circle && accuracy && circle.setRadius(accuracy);
    }, [accuracy, circle]);

    useEffect(() => {
        if (circle && currentUserLoc && activeUser) {
            const latLng = formatLatLng(currentUserLoc.lat, currentUserLoc.lng);
            const prevLatLng = circle.getCenter();
            const callback = (coords) => circle.setCenter(coords);

            const prevLat = prevLatLng.lat();
            const prevLng = prevLatLng.lng();
            const distance = calculateDistance(prevLat, prevLng, currentUserLoc.lat, currentUserLoc.lng);

            if (distance === 0 || distance > 500) {
                return circle.setCenter(latLng);
            } else {
                moveMapEl(currentUserLoc.lat, currentUserLoc.lng, prevLat, prevLng, callback);
            }
        }
    }, [circle, currentUserLoc, activeUser, ormLocations]);


    return null;
};

export default Circle;
